import React, { ComponentProps, FC } from 'react';
import AdvancedModal from '@tovia/man-ui/lib/components/Modal/AdvancedModal';
import styled from 'styled-components/macro';

type Props = ComponentProps<typeof AdvancedModal>;

export const UpgradeNoEnterDialog: FC<Props> = (props) => (
  <StyledModal {...props}>
    <p>
      <strong>You have a trial account with restricted downloads.</strong>
    </p>
    <div>
      Upon completion, unlimited downloads will be available
      <br />
      on your premium membership.
    </div>
  </StyledModal>
);

const StyledModal = styled(AdvancedModal)`
  text-align: center;
`;
